// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__z6u1e","pulse":"styles_pulse__u7c4L","jump":"styles_jump__y6_jR"};